import i18n from '../i18n';

// Dates were formatted with a hardcoded 'en' locale, so a Vietnamese or Chinese user
// saw "Mar 12, 2026" on every screen while the rest of the interface was in their own
// language. Reading i18n.language keeps this a plain function (no hook, so the existing
// non-component callers still work); i18next re-renders the tree on a language change,
// which re-runs these calls.
function activeLocale() {
  return i18n.language || 'en';
}

export function formatDate(value) {
  const date = new Date(value);
  return new Intl.DateTimeFormat(activeLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
}

export function formatDateSlash(value) {
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
}

export function getTodayString() {
  return toLocalISODate(new Date());
}

export function timeAgo(timestamp) {
  const seconds = Math.floor((Date.now() - new Date(timestamp).getTime()) / 1000);
  if (seconds < 60) return 'Just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function getMonthLabel(dateString) {
  return new Intl.DateTimeFormat(activeLocale(), { month: 'short', year: 'numeric' }).format(new Date(dateString));
}

export function toLocalISODate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function getCurrentMonthRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { start: toLocalISODate(start), end: toLocalISODate(end) };
}
